var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17.975L18.2958 17.6791C18.5417 17.4333 24.3833 11.5708 24.3833 6.51248C24.3833 2.98707 21.5254 0.12915 18 0.12915C14.4746 0.12915 11.6167 2.98707 11.6167 6.51248C11.6167 11.5708 17.45 17.4333 17.7042 17.6791L18 17.975ZM18 0.999984C21.0534 0.99306 23.5362 3.45909 23.55 6.51248C23.55 10.6041 19.1875 15.525 18 16.7833C16.8125 15.5333 12.45 10.6041 12.45 6.51248C12.4638 3.45909 14.9466 0.99306 18 0.999984ZM35.5 10.625V26.5875C35.5001 27.3798 35.1246 28.1253 34.4879 28.5968C33.8512 29.0684 33.0287 29.2102 32.2708 28.9792L24.2208 26.5208L11.3333 28.575L11.2542 28.5542L2.41667 26.4375C1.29323 26.1679 0.500846 25.1636 0.500002 24.0083V8.04998C0.498991 7.25648 0.874742 6.50962 1.5125 6.03748C2.14744 5.56203 2.97229 5.42094 3.72917 5.65832L10.6208 7.76248L10.3792 8.55832L3.4875 6.45415C2.98184 6.29948 2.43279 6.39394 2.00789 6.70871C1.583 7.02348 1.33268 7.5212 1.33334 8.04998V24.0083C1.33341 24.7795 1.86249 25.4499 2.6125 25.6292L10.9167 27.6208V13.0833H11.75V27.6667L23.8333 25.7417V13.0833H24.6667V25.7875L32.5125 28.1791C33.0175 28.3336 33.5657 28.2396 33.9904 27.9258C34.4151 27.612 34.666 27.1155 34.6667 26.5875V10.625C34.6666 9.85384 34.1375 9.18344 33.3875 9.00415L25.55 7.12498L25.7458 6.31248L33.5833 8.19582C34.7068 8.46539 35.4992 9.46966 35.5 10.625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0001 10.0834C16.265 10.0834 14.8584 8.67681 14.8584 6.94172C14.8584 5.20662 16.265 3.80005 18.0001 3.80005C19.7352 3.80005 21.1417 5.20662 21.1417 6.94172C21.1394 8.67586 19.7342 10.0811 18.0001 10.0834ZM18.0001 4.63338C16.7252 4.63338 15.6917 5.66686 15.6917 6.94172C15.6917 8.21657 16.7252 9.25005 18.0001 9.25005C19.2749 9.25005 20.3084 8.21657 20.3084 6.94172C20.3061 5.66781 19.274 4.63568 18.0001 4.63338Z",
    fill: "url(#paint0_linear_1256_8728)",
    fillOpacity: 0.93
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1256_8728",
    x1: 14.8584,
    y1: 6.94172,
    x2: 21.1417,
    y2: 6.94172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0079B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#009FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.24151f3c5eff01b7f3bdd00ad0297a92.svg";
export { ForwardRef as ReactComponent };